import { LoadingState } from "../../../root-store/api-result.state";
import { DeviceMetadataActions } from "../actions";
import { CHDeviceMetadataState } from "../clarehome.state";

export const chDeviceMetadatareducer = (
    state: CHDeviceMetadataState = { result: null, uuid: "", callState: LoadingState.init },
    action: DeviceMetadataActions.Actions = null
): CHDeviceMetadataState => {
    switch (action.type) {
        case DeviceMetadataActions.ActionTypes.ClearDeviceMetadata: {
            return {
                ...state,
                uuid: null,
                callState: LoadingState.init,
            };
        }

        case DeviceMetadataActions.ActionTypes.GetDeviceMetadata: {
            return {
                ...state,
                uuid: action.payload.uuid,
                callState: LoadingState.loading,
            };
        }

        case DeviceMetadataActions.ActionTypes.GetDeviceMetadataSuccess: {
            return {
                ...state,
                result: action.result.result,
                uuid: action.result.uuid,
                callState: LoadingState.loaded,
            };
        }

        default: {
            return state;
        }
    }
};
